import React from 'react';
import Table from '@atlaskit/dynamic-table';
import { type IntlShape, injectIntl } from '@atlassian/jira-intl';
import {
	formatEstimate,
	type EstimationStatistic,
} from '@atlassian/jira-software-report-charting-common/src/common/utils/format-estimate/index.tsx';
import type { TimeTrackingOptions } from '@atlassian/jira-time-tracking-formatter/src/types.tsx';
import type { Sprint } from '../../model/types';
import messages from './messages';

export interface Props {
	sprints: Sprint[];
	timeTrackingOptions: TimeTrackingOptions;
	estimationStatistic: EstimationStatistic;
}

export type PropsWithIntl = Props & {
	intl: IntlShape;
};

export function Grid({ sprints, intl, estimationStatistic, timeTrackingOptions }: PropsWithIntl) {
	const head = {
		cells: [
			{
				key: 'name',
				content: intl.formatMessage(messages.sprint),
				isSortable: false,
				width: 80,
			},
			{
				key: 'estimated',
				content: intl.formatMessage(messages.commitment),
				isSortable: false,
				width: 10,
			},
			{
				key: 'completed',
				content: intl.formatMessage(messages.completed),
				isSortable: false,
				width: 10,
			},
		],
	};

	const rows = sprints.map((sprint, index) => ({
		key: `row-${index}-${sprint.id}`,
		cells: [
			{
				key: 'name',
				content: sprint.name,
			},
			{
				key: 'estimated',
				content: formatEstimate(sprint.estimated, timeTrackingOptions, estimationStatistic, intl),
			},
			{
				key: 'completed',
				content: formatEstimate(sprint.completed, timeTrackingOptions, estimationStatistic, intl),
			},
		],
	}));

	// @ts-expect-error - TS2769 - No overload matches this call.
	return <Table head={head} rows={rows} paginationi18n={{ next: '', prev: '' }} />;
}

export default injectIntl(Grid);
